// Slide Previews — extracted from ProposalEditor.js to reduce its size.
// Pure presentational component. No state, no side-effects.

const LOGO_DARK = `${process.env.REACT_APP_BACKEND_URL}/api/static/evolutt_logo.png`;
const LOGO_LIGHT = `${process.env.REACT_APP_BACKEND_URL}/api/static/evolutt_logo_white.png`;

const SlidePreviews = ({ texts, company, result }) => {
  const year = new Date().getFullYear().toString();
  const footerReplaced = (texts.footer_text || "").replace("{ano}", year);
  const motivationalAlign =
    texts.motivational_alignment === "center"
      ? "center"
      : texts.motivational_alignment === "justify"
      ? "justify"
      : "left";
  const thanksAlign =
    texts.thanks_alignment === "center"
      ? "center"
      : texts.thanks_alignment === "justify"
      ? "justify"
      : "left";

  return (
    <div className="grid grid-cols-2 gap-3" data-testid="proposal-slide-previews">
      {/* Slide 1 - Capa */}
      <div className="aspect-video rounded-lg overflow-hidden relative bg-white">
        <div
          className="absolute inset-0"
          style={{ background: "linear-gradient(135deg, #F5E6C8 0%, #FADCBC 25%, #FFF5E8 50%, #FFFFFF 75%)" }}
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center" style={{ paddingBottom: "28%" }}>
          <p className="text-[11px] font-bold text-[var(--brand-primary)]">
            <img src={LOGO_DARK} alt="Evolutt" className="h-4 inline-block" />
          </p>
          <p className="text-[6px] text-[#466464]">{company.company_slogan}</p>
        </div>
        <div className="absolute bottom-3 left-0 right-0 text-center">
          <p className="text-[9px] font-bold text-[var(--brand-primary)]">{texts.cover_title}</p>
          {texts.cover_subtitle && <p className="text-[6px] text-[#466464]">{texts.cover_subtitle}</p>}
          <p className="text-[5px] text-[#505050]">{year}</p>
        </div>
        <p className="absolute top-1 right-1.5 text-[6px] text-[#A0B4B4]/70">Capa</p>
      </div>

      {/* Slide 2 - Proposta Pessoal */}
      <div className="aspect-video rounded-lg overflow-hidden bg-white border p-2 flex flex-col relative">
        <div className="bg-[var(--brand-primary)] rounded-t-sm px-2 py-0.5 -mx-2 -mt-2 mb-1.5 flex items-center justify-between">
          <img src={LOGO_LIGHT} alt="Evolutt" className="h-2.5" />
          <p className="text-[6px] text-[#FADCBC] font-bold">{texts.cover_title}</p>
        </div>
        <p className="text-[8px] font-bold text-[var(--brand-primary)]">{texts.greeting_text}</p>
        <p className="text-[5px] text-[#505050] mt-0.5 line-clamp-2" style={{ textAlign: motivationalAlign }}>
          {texts.motivational_text}
        </p>
        <div className="mt-auto">
          <div className="bg-[var(--brand-primary)] text-white text-[5px] px-1 py-0.5 flex justify-between">
            <span className="w-[45%]">Componente</span>
            <span className="w-[27%] text-center">Mensal</span>
            <span className="w-[28%] text-center">Anual</span>
          </div>
          {result && (
            <div className="text-[5px]">
              <div className="flex justify-between px-1 py-px bg-[#E8F0F0]">
                <span className="w-[45%] font-semibold">Salário Bruto</span>
                <span className="w-[27%] text-center">{result.gross_monthly?.toFixed(0)}€</span>
                <span className="w-[28%] text-center">{(result.gross_monthly * 14)?.toFixed(0)}€</span>
              </div>
              {result.include_iht && (
                <>
                  <div className="flex justify-between px-1 py-px">
                    <span className="w-[45%] text-[#505050]">Base (80%)</span>
                    <span className="w-[27%] text-center">{(result.gross_monthly * 0.8)?.toFixed(0)}€</span>
                    <span className="w-[28%] text-center">{(result.gross_monthly * 0.8 * 14)?.toFixed(0)}€</span>
                  </div>
                  <div className="flex justify-between px-1 py-px bg-[#E8F0F0]">
                    <span className="w-[45%] text-[#505050]">IHT (20%)</span>
                    <span className="w-[27%] text-center">{(result.gross_monthly * 0.2)?.toFixed(0)}€</span>
                    <span className="w-[28%] text-center">{(result.gross_monthly * 0.2 * 14)?.toFixed(0)}€</span>
                  </div>
                </>
              )}
              {result.meal_allowance > 0 && (
                <div className="flex justify-between px-1 py-px">
                  <span className="w-[45%]">Sub. Alimentação</span>
                  <span className="w-[27%] text-center">{result.meal_allowance?.toFixed(0)}€</span>
                  <span className="w-[28%] text-center">{(result.meal_allowance * 11)?.toFixed(0)}€</span>
                </div>
              )}
              {result.health_insurance > 0 && (
                <div className="flex justify-between px-1 py-px bg-[#E8F0F0]">
                  <span className="w-[45%]">Seguro Saúde</span>
                  <span className="w-[27%] text-center">{result.health_insurance?.toFixed(0)}€</span>
                  <span className="w-[28%] text-center">{(result.health_insurance * 12)?.toFixed(0)}€</span>
                </div>
              )}
              {result.insurance_capitalization > 0 && (
                <div className="flex justify-between px-1 py-px">
                  <span className="w-[45%]">Real Vida</span>
                  <span className="w-[27%] text-center">{result.insurance_capitalization?.toFixed(0)}€</span>
                  <span className="w-[28%] text-center">{(result.insurance_capitalization * 12)?.toFixed(0)}€</span>
                </div>
              )}
              {result.km_allowance > 0 && (
                <div className="flex justify-between px-1 py-px bg-[#E8F0F0]">
                  <span className="w-[45%]">Deslocação</span>
                  <span className="w-[27%] text-center">{result.km_allowance?.toFixed(0)}€</span>
                  <span className="w-[28%] text-center">{(result.km_allowance * 11)?.toFixed(0)}€</span>
                </div>
              )}
              <div className="flex justify-between px-1 py-px text-red-600">
                <span className="w-[45%]">SS (11%)</span>
                <span className="w-[27%] text-center">-{result.social_security_employee?.toFixed(0)}€</span>
                <span className="w-[28%] text-center"></span>
              </div>
              <div className="flex justify-between px-1 py-px text-red-600 bg-[#E8F0F0]">
                <span className="w-[45%]">
                  IRS ({result.gross_monthly ? ((result.irs_retention / result.gross_monthly) * 100).toFixed(1) : 0}%)
                </span>
                <span className="w-[27%] text-center">-{result.irs_retention?.toFixed(0)}€</span>
                <span className="w-[28%] text-center"></span>
              </div>
              <div className="flex justify-between px-1 py-0.5 bg-[#FADCBC]/40 font-bold text-[var(--brand-primary)]">
                <span className="w-[45%]">Líquido (12m)</span>
                <span className="w-[27%] text-center">{result.net_monthly?.toFixed(0)}€</span>
                <span className="w-[28%] text-center"></span>
              </div>
            </div>
          )}
        </div>
        <div className="text-center mt-0.5">
          <p className="text-[4px] text-[#505050]">{footerReplaced}</p>
        </div>
        <p className="absolute top-0.5 right-1.5 text-[6px] text-[#A0B4B4]/70">Slide 2</p>
      </div>

      {/* Slide 3 - Visão Anual */}
      <div className="aspect-video rounded-lg overflow-hidden bg-white border p-2 flex flex-col relative">
        <div className="bg-[var(--brand-primary)] rounded-t-sm px-2 py-0.5 -mx-2 -mt-2 mb-1.5 flex items-center justify-between">
          <img src={LOGO_LIGHT} alt="Evolutt" className="h-2.5" />
          <p className="text-[6px] text-[#FADCBC] font-bold">{texts.annual_title}</p>
        </div>
        <p className="text-[7px] text-center text-[#466464] mb-1">{texts.annual_subtitle}</p>
        <div className="flex-1 flex items-center justify-center">
          <div className="w-full">
            <div className="flex gap-px mb-px">
              <div className="w-[20%] h-2 bg-[var(--brand-primary)] rounded-sm"></div>
              {["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"].map((m, i) => (
                <div
                  key={`month-hdr-${i}`}
                  className="flex-1 h-2 bg-[var(--brand-primary)] rounded-sm flex items-center justify-center"
                >
                  <span className="text-[3px] text-white">{m}</span>
                </div>
              ))}
              <div className="w-[8%] h-2 bg-[var(--brand-primary)] rounded-sm flex items-center justify-center">
                <span className="text-[3px] text-white">T</span>
              </div>
            </div>
            {["Bruto", "Base", "IHT", "Sub.Al", "SS", "IRS"].map((label, ri) => (
              <div key={`row-${label}`} className="flex gap-px mb-px">
                <div
                  className={`w-[20%] h-1.5 ${ri % 2 === 0 ? "bg-[#E8F0F0]" : "bg-white"} rounded-sm flex items-center`}
                >
                  <span className="text-[3px] text-[var(--brand-primary)] pl-0.5">{label}</span>
                </div>
                {Array.from({ length: 12 }, (_, i) => (
                  <div
                    key={`${label}-cell-${i}`}
                    className={`flex-1 h-1.5 ${ri % 2 === 0 ? "bg-[#E8F0F0]" : "bg-white"} rounded-sm`}
                  ></div>
                ))}
                <div className={`w-[8%] h-1.5 ${ri % 2 === 0 ? "bg-[#FADCBC]/30" : "bg-white"} rounded-sm`}></div>
              </div>
            ))}
            <div className="flex gap-px mt-px">
              <div className="w-[20%] h-2 bg-[#FADCBC] rounded-sm flex items-center">
                <span className="text-[3px] text-[var(--brand-primary)] font-bold pl-0.5">Líquido</span>
              </div>
              {Array.from({ length: 12 }, (_, i) => (
                <div key={`liq-cell-${i}`} className="flex-1 h-2 bg-[#FADCBC]/60 rounded-sm"></div>
              ))}
              <div className="w-[8%] h-2 bg-[#FADCBC] rounded-sm"></div>
            </div>
          </div>
        </div>
        <div className="text-center mt-0.5">
          <p className="text-[4px] text-[#505050]">{footerReplaced}</p>
        </div>
        <p className="absolute top-0.5 right-1.5 text-[6px] text-[#A0B4B4]/70">Slide 3</p>
      </div>

      {/* Slide 4 - Obrigado */}
      <div className="aspect-video rounded-lg overflow-hidden bg-[var(--brand-primary)] p-3 flex flex-col items-center justify-center text-center relative">
        <p className="text-xs font-bold text-white">{texts.thanks_title}</p>
        <p className="text-[6px] text-[#C8DCDC] mt-1 line-clamp-2 max-w-[80%]" style={{ textAlign: thanksAlign }}>
          {texts.thanks_text}
        </p>
        <div className="mt-2 space-y-0.5">
          {company.company_address && (
            <p className="text-[5px] text-[#FADCBC]">
              {company.company_address} {company.company_postal_code} {company.company_city}
            </p>
          )}
          {company.company_phone1 && (
            <p className="text-[5px] text-[#FADCBC]">
              {company.company_phone1}
              {company.company_phone2 ? ` | ${company.company_phone2}` : ""}
            </p>
          )}
          {company.company_website && <p className="text-[5px] text-[#A0B4B4]">{company.company_website}</p>}
          {company.company_email && <p className="text-[5px] text-[#A0B4B4]">{company.company_email}</p>}
        </div>
        <div className="absolute bottom-1.5 left-0 right-0 text-center">
          <p className="text-[4px] text-[#466464]">{footerReplaced}</p>
        </div>
        <p className="absolute top-1 right-1.5 text-[6px] text-[#A0B4B4]/70">Slide 4</p>
      </div>
    </div>
  );
};

export default SlidePreviews;
